"use strict";

import AxiosService from "../AxiosService";

const WORKLIST_MECHANIC = "/api/v1/addresses/visits";
const WORKLIST_MECHANIC_OVERDUE = "/api/v1/addresses/visits/overdue";
const WORKLIST_MECHANIC_ALL = "/api/v1/addresses/visits/mechanic";

export default class AssignmentService {
  constructor() {
    this.service = new AxiosService();
  }

  resolveAddresses(query) {
    var queryParam = [];

    if (query.pageSize) {
      queryParam.push("size=" + query.pageSize);
    }
    if (query.pageNumber) {
      queryParam.push("page=" + query.pageNumber);
    }
    if (query.date) {
      queryParam.push("date=" + query.date);
    }

    return this.service.get(
      WORKLIST_MECHANIC + "?" + queryParam.join("&")
    );
  }

  resolveAddressesOverdue(query) {
    var queryParam = [];

    if (query.pageSize) {
      queryParam.push("size=" + query.pageSize);
    }
    if (query.pageNumber) {
      queryParam.push("page=" + query.pageNumber);
    }

    return this.service.get(
      WORKLIST_MECHANIC_OVERDUE + "?" + queryParam.join("&")
    );
  }

  resolveAllMechanic() {
    return this.service.get(WORKLIST_MECHANIC_ALL);
  }
}
